<template>
	<div id="Library">

		<div id="messaggio" style="position:fixed;top:0;left:0;width:100%;background-color:#3FFF82;color:#383838;z-index:9999;padding:0.7em;display:none;">
			<div>
			Grazie! La tua richiesta è stata inoltrata. Ti risponderemo a breve.
			</div>
		</div>

		<div class="section banner">
			<div class="ratio-box">
				<iframe class="presentation-video" src="https://youtube.com/embed/hk5T6bM_Aq4?autoplay=1&mute=1" frameborder="0" allowfullscreen></iframe>
			</div>
		</div>

		<div class="section" v-if="!me || !me.membership">
			<div class="library-info">
			<h2 class="section-title" id="up">EXIMUS ONLINE TRAINING</h2>
			<h3 style="font-size:2em; text-align: center;">Allenati da casa come in palestra a soli 9,90€/mese!</h3>
			<div class="divprova">
				<button class="provagratuita" id="provagratuita" @click="provagratuita()">Richiedi la PROVA GRATUITA</button>

			<div class="contact-form" id="formprovagratuita" style="display:none; text-align:left;">
				<form class="pad-l" @submit.prevent="requestAccess">
					<div class="title">Compila con i tuoi dati e richiedi la prova!</div>

					<div class="input-grid">
						<div class="form-input">
							<label>nome</label>
							<input type="text" v-model="formData.firstName" name="first_name" placeholder="nome" required/>
						</div>

						<div class="form-input">
							<label>cognome</label>
							<input type="text" v-model="formData.lastName" name="last_name" placeholder="cognome" required/>
						</div>

						<div class="form-input">
							<label>email</label>
							<input type="email" v-model="formData.email" name="email" placeholder="email" required/>
						</div>

						<div class="form-input">
							<label>servizio</label>
							<select v-model="formData.service">
								<option value="prova gratuita">2 giorni di prova gratuita</option>
							</select>
						</div>

						<div class="submit">
							<button class="richiesta">Richiedi la PROVA GRATUITA</button>
						</div>
					</div>
				</form>
			</div>

			</div>
			<h3 style="font-size:2em; text-align: center;">Dove vuoi, quando vuoi, con la solita qualità di Eximus</h3>
				<div class="container-desktop pad-l">
					<div class="info" style="font-size:1.2em;">
						<b><span style="color:#ffe010;">Eximus Online Training</span></b> è la nuova piattaforma di Eximus Performance per l'allenamento a casa.<br>
						Avrai accesso a decine di video allenamenti specifici per ogni obiettivo, <span style="color:#ffe010;"><b>ti allenerai seguendo i nostri coach</b></span> come fossimo in diretta insieme, <span style="color:#ffe010;"><b>con consigli, tempi di esecuzione, tempi di recupero e varianti.</b></span>
						
							<div class="divpres">
								<p><b>All'interno troverai:</b></p>
								<div class="divbox">
								<img src="@/assets/devices_2.png" style="max-width: 128px;">
								<div class="divul">
								<ul class="presdesc">
									<li>30+ video-allenamenti completi</li>
									<li>200 tra video-schede ed esercizi</li>
									<li>1000+ minuti di video in hd</li>
									<li>spiegazioni dettagliate</li>
									<li>programmi personalizzati</li>
								</ul>
								</div>
								</div>
							</div>
							<div class="divpres">
							<p><b>Divisi in:</b></p>
								<div class="divbox">
								<img src="@/assets/training_2.png" style="max-width: 128px;">
								<div class="divul">
								<ul class="presdesc">
									<li>Allenamento Funzionale</li>
									<li>Total Body</li>
									<li>Core e addominali</li>
									<li>Cardio e metabolico</li>
									<li>Gambe e glutei</li>
									<li>Upper Body</li>
									<li>Mobilità e Stretching</li>
								</ul>
								</div>
								</div>
							</div>

							<div class="divpres">
							<p><b>In base all'attrezzatura:</b></p>
								<div class="divbox">
								<img src="@/assets/attrezzi_2.png" style="max-width: 128px;">
								<div class="divul">
								<ul class="presdesc">
									<li>Kettlebell</li>
									<li>Manubri</li>
									<li>TRX</li>
									<li>Elastici</li>
									<li>Slider</li>
								</ul>
								</div>
								</div>
							</div>

							<div class="divpres">
								<p><b>Diviso per livelli:</b></p>
								<div class="divbox">
								<img src="@/assets/obiettivi_2.png" style="max-width: 128px;">
									<ul class="presdesc">
										<li>Base, Intermedio, Avanzato</li>
									</ul>
								</div>
								<p><b>...e per obiettivi:</b></p>
								<div class="divbox">
									<ul class="presdesc">
										<li>Tonificazione, Dimagrimento, Aumento massa</li>
									</ul>
								</div>
							</div>

					</div>
				</div>

								<div class="divprova">
									<button class="provagratuita" id="provagratuita2" @click="provagratuita2()">Richiedi la PROVA GRATUITA</button>

									<div class="contact-form" id="formprovagratuita2" style="display:none; text-align:left;">
										<form class="pad-l" @submit.prevent="requestAccess">
											<div class="title">Compila con i tuoi dati e richiedi la prova!</div>

											<div class="input-grid">
												<div class="form-input">
													<label>nome</label>
													<input type="text" v-model="formData.firstName" name="first_name" placeholder="nome" required/>
												</div>

												<div class="form-input">
													<label>cognome</label>
													<input type="text" v-model="formData.lastName" name="last_name" placeholder="cognome" required/>
												</div>

												<div class="form-input">
													<label>email</label>
													<input type="email" v-model="formData.email" name="email" placeholder="email" required/>
												</div>

												<div class="form-input">
													<label>servizio</label>
													<select v-model="formData.service">
														<option value="prova gratuita">2 giorni di prova gratuita</option>
													</select>
												</div>

												<div class="submit">
													<button class="richiesta">Richiedi la PROVA GRATUITA</button>
												</div>
											</div>
										</form>
									</div>
								</div>
			</div>

			<div class="library-info2">
				<h2 class="section-title">Come Funziona?</h2>

				<div class="container-desktop pad-l">
					<div class="info" style="font-size:1.2em;">
						<ul><li>Al costo di <b><u><span style="color:#ffe010;">9,90€ / mese</span></u></b>, avrai <b>accesso illimitato a tutti i video della piattaforma online</b>!</li></ul>
					</div>
				</div>
				<div class="container-desktop pad-l">
					<div class="p-relative">
						<div class="bar">
							<Card class="bg-darker" title="Eximus Online Training" :image="require('@/assets/eximus_online.png')"><p>Accesso illimitato a tutti i video della piattaforma online. </p><p><u><b>9,90€ / mese.</b></u></p></Card>
							<Card class="bg-darker" title="Personal Training Online" :image="require('@/assets/pt_zoom.jpg')"><p>Allenamenti personalizzati in base all'obiettivo, attrezzatura e spazio a disposizione.</p><p><b><u>400,00€ / 10 lezioni</u></b></p></Card>
						</div>
					</div>
					<div style="font-size:1.2em;">
					<br>Troverai sia <b><span style="color:#ffe010;">video allenamenti</span></b> completi, dove il coach eseguirà tutto il workout dal warmup all'allungamento finale, sia <b><span style="color:#ffe010;">video-schede</span></b> in cui illustreremo l'allenamento, spiegheremo gli esercizi e le modalità con tutta la qualità che ci contraddistingue.<br>
						In questo modo potrai svolgere l'allenamento <span style="color:#ffe010;"><b>in totale autonomia, dove e quando vuoi, senza improvvisare nulla.</b></span><br><br>
						In alternativa, per chi cerca un lavoro ancora più personalizzato, è attivo anche il servizio di <b><span style="color:#ffe010;">personal training online</span></b> sempre su Zoom.
					</div>
				</div>
			</div>

			<div class="library-info">
				<h2 class="section-title">Dai una sbirciata a quello che troverai...</h2>
				<div class="container-desktop pad-l">
					<div class="category">
						<div class="videos">
							<VideoCard v-for="video in filteredVideos2" :key="video.id"
							:video="video"/>
						</div>
					</div>
				</div>
			</div>

			<div class="library-info">
				<h2 class="section-title">Perchè dovresti sceglierci?</h2>
				<div class="container-desktop pad-l">
					<div class="info" style="font-size:1.2em;">
					<img src="@/assets/badge_2.png" style="display:block; margin:0 auto; max-width:128px;">
						<p>
							Internet è ormai pieno di siti e applicazioni a prezzi bassissimi se non addidrittura gratis, che propongono tantissimi allenamenti stravaganti
							di ogni tipo. 
							<br>Il nostro obiettivo non è quello di fare concorrenza a queste piattaforme ma è quello di <span style="color:#ffe010;"><b>portare un lavoro di qualità</b></span> (come quello che proponiamo
							in palestra tutti i giorni) a più persone possibili che non possono allenarsi da noi e che hanno poca, se non nessuna attrezzatura a disposizione. 
							<br>In questo particolare momento storico, <span style="color:#ffe010;"><b>continuare ad allenarsi è di fondamentale importanza</b></span> per la salute sia fisica che mentale, ma lo è ancora di
							più <span style="color:#ffe010;"><b>allenarsi bene e con intelligenza</b></span> seguendo dei professionisti del settore, per evitare spiacevoli infortuni, incidenti e per massimizzare i
							risultati.
							<br>Per questo sulla nostra piattaforma non troverai allenamenti "alla moda" con esercizi fatti solo per sudare, ma <span style="color:#ffe010;"><b>allenamenti con esercizi e programmazioni
							studiati e testati con base scientifica.</b></span>
						</p>
					</div>
				</div>
			</div>
		
			<div class="contact-form">
				<form class="pad-l" @submit.prevent="requestAccess">
					<div class="title">Scegli il servizio e allenati con noi!</div>

					<div class="input-grid">
						<div class="form-input">
							<label>nome</label>
							<input type="text" v-model="formData.firstName" name="first_name" placeholder="nome" required/>
						</div>

						<div class="form-input">
							<label>cognome</label>
							<input type="text" v-model="formData.lastName" name="last_name" placeholder="cognome" required/>
						</div>

						<div class="form-input">
							<label>email</label>
							<input type="email" v-model="formData.email" name="email" placeholder="email" required/>
						</div>

						<div class="form-input">
							<label>servizio</label>
							<select v-model="formData2.service">
								<option value="EOT">Eximus Online Training - Abbonamento mensile</option>
								<option value="PT">Personal Training</option>
							</select>
						</div>

						<div class="form-input">
							<label>Messaggio (opzionale)</label>
							<textarea rows="5" v-model="formData.message" name="message" placeholder="..."></textarea>
						</div>

						<div class="submit">
							<button class="richiesta">RICHIEDI L'ACCESSO</button>
						</div>
					</div>
				</form>
			</div>
		</div>

		<div class="section" v-else>
		
			<div class=up onclick="javascript:location.href='#up'">
				<img :src="require('@/assets/up.png')" width="85%" style="margin-left:3px;margin-top:2px;cursor:pointer;"/>
			</div>

			<div class="library-info">
				<h2 class="section-title" id="up">EXIMUS ONLINE TRAINING</h2>
				<h3 style="font-size:2em; text-align: center;">Allenati dove vuoi, quando vuoi, con la solita qualità di Eximus!</h3>
					<div class="container-desktop pad-l">
						<div class="info" style="font-size:1.2em;">
							<b>Eximus Online Training</b> è la nuova piattaforma di Eximus Performance per l'allenamento a casa.<br>
							Avrai accesso a decine di video allenamenti specifici per ogni obiettivo, ti allenerai seguendo i nostri coach come fossimo in diretta insieme, con consigli, tempi di esecuzione, tempi di recupero e varianti.
						</div>
					</div>
			</div>
			<p style="margin-left:1.5em; font-size:1.1em;">Filtra per tipologia, livello e attrezzatura:</p>
			<div class="menublog" v-for="(cat, i) in categories" :key="i">
				<div class="filtro">
					<div class="catcont">
						<div class="categoria" v-for="[tag, text] in Object.entries(cat)" :key="tag">
							<span class="link t-uppercase" :class="{active: activeTags.findIndex((t) => t === tag) !== -1}" @click="toggleTag(tag)">{{ text }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="category" v-if="videosByTag.general.length > 0">
				<h3>general</h3>

				<div class="videos">
					<VideoCard v-for="video in videosByTag.general" :key="video.id"
						:video="video"/>
				</div>
			</div>
			<div class="category">
				<div class="empty" style="text-align:center; font-size:1.1em; margin-bottom:2.5em; margin-top:-2em" v-if="filteredVideos.length === 0">
				Usa i filtri per visualizzare i video che cerchi
				</div>
				<p style="text-align:center; font-size:1.1em; margin-bottom:2em; margin-top:-2em;">
					Usa i filtri per visualizzare i video che cerchi
				</p>
				<div class="progselect" v-if="filteredVideos.length === 0 || filteredVideos.length > 0">
							<h3>Consigli per la Programmazione</h3>
					<div class="divprogramma">
						<select id="livello" class="programma" @change="progselect()">
							<option value="null"><b>-- Livello --</b></option>
							<option value="base">Base</option>
							<option value="inter">Intermedio</option>
							<option value="advance">Avanzato</option>
						</select>
						<select id="focus" class="programma" @change="progselect()">
							<option value="null"><b>-- Obiettivo --</b></option>
							<option value="toni">Tonificazione</option>
							<option value="loose">Dimagrimento</option>
							<option value="mass">Aumento massa</option>
						</select>
						<select id="days" class="programma" @change="progselect()">
							<option value="null"><b>-- Frequenza --</b></option>
							<option value="2">2/settimana</option>
							<option value="3">3/settimana</option>
							<option value="4">4/settimana</option>
						</select>
					</div>
					<div class=progworkout>
							<p id="workout1">Seleziona il tuo livello, l'obiettivo e la frequenza settimanale</p>
							<p id="workout2"></p>
							<p id="workout3"></p>
							<p id="workout4"></p>
					</div>
					
				</div>
				<h3 v-if="activeTags.length === 0">Ultimi video aggiunti</h3>
				<div class="videos">
					<VideoCard v-for="video in filteredVideos" :key="video.id"
						:video="video"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/api'
import VideoCard from '@/components/library/VideoCard'
import pop, { notif } from '@/pop'
import Card from '@/components/home/Card'

export default {
	name: 'Library',

	components: {
		VideoCard,
		Card
	},

	data() {

		return {
			/// Authenticated user
			me: null,

			/// Loaded videos
			videos: [],

			/// Request form
			formData: {
				firstName: '',
				lastName: '',
				email: '',
				message: '',
				service: 'prova gratuita'
			},

			/// Request form2 
			formData2: {
				firstName: '',
				lastName: '',
				email: '',
				message: '',
				service: 'EOT'
			},

			/// Video categories
			categories: [
				{
					workout: 'workout',
					'video-scheda': 'video-scheda',
					core: 'core/addome',
					mobilità: 'mobilità',
					cardio: 'cardio',
					'total body': 'total body',
					'upper body': 'upper body',
					gambe: 'gambe'
				},
				{
					base: 'base',
					intermedio: 'intermedio',
					avanzato: 'avanzato',
					women: 'women'
				},
				{
					manubri: 'manubri',
					kettlebell: 'kettlebell',
					trx: 'trx',
					elastici: 'elastici',
					slider: 'slider'
				}
			],

			/// Active tags
			activeTags: []
		}
	},

	computed: {
		/**
		 * 
		 */
		filteredVideos2() {

			return this.activeTags.length === 0 ? [
		{'id': 'DSr4ze9Yvas', 'title': 'Workout functional total body livello Base 1', 'tags': ['workout', 'base', 'total body'], 'description': ''},
		{'id': 'ddK-8RxInNE', 'title': 'Cardio & Core 1', 'tags': ['cardio', 'core', 'video-scheda'], 'description': ''},
		{'id': 'um-wwpWr-J8', 'title': 'Workout TRX 2', 'tags': ['video-scheda', 'total body', 'trx'], 'description': ''},
		] : this.videos.filter((video) => this.activeTags.some((tag) => video.tags.findIndex((t) => t == tag) !== -1))
		},

		filteredVideos() {

			return this.activeTags.length === 0 ? [
		{'id': 'QHpwcsDTmw8', 'title': 'Cardio - Tabata 4', 'tags': ['cardio'], 'description': ''},
		{'id': 'Sz8qE_iv0H0', 'title': 'Workout functional total body intermedio 6', 'tags': ['workout', 'total body', 'kettlebell', 'manubri', 'intermedio'], 'description': ''},
		{'id': 'iJQXPAzqXr4', 'title': 'Cardio & Core 4', 'tags': ['cardio', 'core', 'video-scheda'], 'description': ''},
		] : this.videos.filter((video) => this.activeTags.some((tag) => video.tags.findIndex((t) => t == tag) !== -1))
		},

		/**
		 *
		 */
		videoTags() {

			return new Set(this.filteredVideos.reduce((tags, video) => [ ...tags, ...video.tags ], []))
		},

		/**
		 *
		 */
		videosByTag() {
			
			let videos = {
				general: []
			}

			for (let video of this.filteredVideos)
			{
				if (video.tags.length === 0)
				{
					videos.general.push(video)
				}
				else
				{
					for (let tag of video.tags)
					{
						videos[tag] = videos[tag] || []
						videos[tag].push(video)
					}
				}
			}

			return videos

			if (this.$route.query.tags)
			{
				const tags = this.$route.query.tags.split(',')
				return this.videos.filter((video) => {
					
					for (let tagid of video.tags)
					{
						const name = this.tags[tagid].name
						if (tags.indexOf(name) !== -1) return true
					}

					return false;
				})
			}
			else return this.videos
		}
	},

	methods: {
		/**
		 * 
		 */
		provagratuita2(){

			var formprova = document.getElementById("formprovagratuita2");
			var bottone = document.getElementById("provagratuita2");

			if(formprova.style.display == "none")
			{
				formprova.style.display = "block";
				bottone.innerHTML = "X";
				
			}
			else if(formprova.style.display == "block")
			{
				formprova.style.display = "none";
				bottone.innerHTML = "Richiedi la PROVA GRATUITA";
			}
		},
		provagratuita(){

			var formprova = document.getElementById("formprovagratuita");
			var bottone = document.getElementById("provagratuita");

			if(formprova.style.display == "none")
			{
				formprova.style.display = "block";
				bottone.innerHTML = "X";
				
			}
			else if(formprova.style.display == "block")
			{
				formprova.style.display = "none";
				bottone.innerHTML = "Richiedi la PROVA GRATUITA";
			}
		},

		progselect(){

				var livello = document.getElementById("livello");
				var focus = document.getElementById("focus");
				var days = document.getElementById("days");
				var workout1 = document.getElementById("workout1");
				var workout2 = document.getElementById("workout2");
				var workout3 = document.getElementById("workout3");
				var workout4 = document.getElementById("workout4");

				if(livello.value == "null" || focus.value == "null" || days.value == "null")
				{
					workout1.innerHTML = "Seleziona il tuo livello, l'obiettivo e la frequenza settimanale";	
					workout2.innerHTML = "";	
					workout3.innerHTML = "";
					workout4.innerHTML = "";	
				}

				else if(livello.value == "base" && focus.value == "toni" && days.value == "2") 
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Base";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}
				else if(livello.value == "base" && focus.value == "loose" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}
				else if(livello.value == "base" && focus.value == "mass" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout TRX Total Body";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}

				else if(livello.value == "inter" && focus.value == "toni" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Intermedio";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}
				else if(livello.value == "inter" && focus.value == "loose" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}
				else if(livello.value == "inter" && focus.value == "mass" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Slider";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Intermedio";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}

				else if(livello.value == "advance" && focus.value == "toni" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Avanzato";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}
				else if(livello.value == "advance" && focus.value == "loose" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}
				else if(livello.value == "advance" && focus.value == "mass" && days.value == "2")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Manubri/Kettlebell";
					workout3.innerHTML = "";
					workout4.innerHTML = "";
				}

				else if(livello.value == "base" && focus.value == "toni" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Base";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Base";
					workout4.innerHTML = "";
				}
				else if(livello.value == "base" && focus.value == "loose" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "<b>Giorno 3: </b>Core Workout Base + Tabata";
					workout4.innerHTML = "";
				}
				else if(livello.value == "base" && focus.value == "mass" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout TRX";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Manubri/Kettlebell";
					workout4.innerHTML = "";
				}

				else if(livello.value == "inter" && focus.value == "toni" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Intermedio";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Intermedio";
					workout4.innerHTML = "";
				}
				else if(livello.value == "inter" && focus.value == "loose" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "<b>Giorno 3: </b>Core Workout Intermedio + Tabata x2 giri";
					workout4.innerHTML = "";
				}
				else if(livello.value == "inter" && focus.value == "mass" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout TRX";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Manubri/Kettlebell";
					workout4.innerHTML = "";
				}

				else if(livello.value == "advance" && focus.value == "toni" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Avanzato";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Avanzato";
					workout4.innerHTML = "";
				}
				else if(livello.value == "advance" && focus.value == "loose" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "<b>Giorno 3: </b>Core Workout Avanzato + Tabata x2 giri";
					workout4.innerHTML = "";
				}
				else if(livello.value == "advance" && focus.value == "mass" && days.value == "3")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Manubri/Kettlebell";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Functional Total Body Avanzato";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Slider";
					workout4.innerHTML = "";
				}

				else if(livello.value == "base" && focus.value == "toni" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout TRX";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Base";
					workout4.innerHTML = "<b>Giorno 4: </b>Cardio & Core";
				}
				else if(livello.value == "base" && focus.value == "loose" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Base";
					workout4.innerHTML = "<b>Giorno 4: </b>Core Workout Base + Tabata";
				}
				else if(livello.value == "base" && focus.value == "mass" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Base";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout TRX";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Manubri/Kettlebell";
					workout4.innerHTML = "<b>Giorno 4: </b>Workout Slider";
				}

				else if(livello.value == "inter" && focus.value == "toni" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Slider";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Intermedio";
					workout4.innerHTML = "<b>Giorno 4: </b>Cardio & Core";
				}
				else if(livello.value == "inter" && focus.value == "loose" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Intermedio";
					workout4.innerHTML = "<b>Giorno 4: </b>Core Workout Intermedio + Tabata";
				}
				else if(livello.value == "inter" && focus.value == "mass" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Intermedio";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Manubri/Kettlebell";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Intermedio";
					workout4.innerHTML = "<b>Giorno 4: </b>Workout TRX";
				}

				else if(livello.value == "advance" && focus.value == "toni" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout TRX";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Avanzato";
					workout4.innerHTML = "<b>Giorno 4: </b>Cardio & Core";
				}
				else if(livello.value == "advance" && focus.value == "loose" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Cardio & Core";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Avanzato";
					workout4.innerHTML = "<b>Giorno 4: </b>Core Workout Avanzato + Tabata x2 giri";
				}
				else if(livello.value == "advance" && focus.value == "mass" && days.value == "4")
				{
					workout1.innerHTML = "<b>Giorno 1: </b>Workout Functional Total Body Avanzato";
					workout2.innerHTML = "<b>Giorno 2: </b>Workout Manubri/Kettlebell";
					workout3.innerHTML = "<b>Giorno 3: </b>Workout Functional Total Body Avanzato";
					workout4.innerHTML = "<b>Giorno 4: </b>Workout Slider";
				}

		},

		async requestAccess() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/eot-access', /* data */{
					first_name: this.formData.firstName,
					last_name: this.formData.lastName,
					email: this.formData.email,
					service: this.formData.service,
					message: this.formData.message
				}, /* bJson */true)

				notif.ok('La tua richiesta è stata inoltrata')
			}
			catch (e)
			{
			/*	console.error('Grazie! La tua richiesta è stata inoltrata. Ti risponderemo a breve.')
				notif.error('Grazie! La tua richiesta è stata inoltrata. Ti risponderemo a breve.') */
  				document.getElementById("messaggio").style.display = "block";
			}
		},

		/**
		 * 
		 */
		toggleTag(tag) {
			
			const tagidx = this.activeTags.findIndex((t) => t === tag)
			if (tagidx === -1)
			{
				this.activeTags.push(tag)
			}
			else
			{
				this.activeTags.splice(tagidx, 1)
			}
		}
	},

	mounted() {

		window.scrollTo(0, 0)
	},

	async beforeRouteEnter(to, from, next) {

		try
		{
			console.log('hey')

			let [ me, videos ] = await Promise.all([
				api.user().me(),
				api.user().getVideos()
			])

			next((vm) => {

				vm.me = me
				vm.videos = videos

				if (!!me)
				{
					vm.formData = { ...me }
				}
			})
		}
		catch (err)
		{
			console.error(err)

			next((vm) => {

				vm.me = null
				vm.videos = []
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
#Library

.form-input select
	max-width 100%

	.banner
		margin-top 0 !important

		.ratio-box
			width 100%

			position relative

			padding-bottom 30%

			background-color @darker

			.presentation-video
				width 100%
				height 100%

				display block

				position absolute
				z-index 1
	
	.contact-form
		margin 1.5em
		padding 2em

		background-color dark

		.title
			font-size 1.2em
		
		.input-grid
			margin-top 1.5em

			.form-input
				margin 0.5em 0

				box-sizing border-box
				
				label
					display block

					margin-bottom 0.4em

					font-size 0.8em

				input
					width 100%

					display block
				
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
				
				select
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em
				
				textarea
					width 100%

					display block

					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-family fontSans
					font-size 1.1em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
			
			.submit
				margin-top 4em

				button
					width 100%

					padding 0.6em
					border none

					background-color primary
					color dark

					font-family fontSans
					font-size 1.3em

					cursor pointer

					transition 0.2s ease

					&:focus
						outline none
	
	.category
		max-width 1280px

		margin auto
		padding 1em

		h3
			padding 0.6em
			border-bottom 1px solid secondary

			font-size 1.5em
			text-transform capitalize

		.videos
			max-width 1280px

			display grid
			grid-template-columns repeat(3, 1fr)
			grid-gap 1em

			margin auto

			@media screen and (max-width: 767px)
				grid-template-columns auto

.bar
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.filtro
	width 100%
	background #101418
	height 3em
	margin-bottom 3em

	@media (max-width: unit(850, px))
		height 100%
		padding-bottom 0.7em

.catcont
	width 850px
	margin 0 auto
	position relative
	display flex
	padding-top 0.6em

	@media (max-width: unit(850, px))
		width 100%
		display grid

.categoria
	text-transform uppercase
	font-size 1.1em
	font-weight bold
	margin 0 auto

.link
	text-decoration none 
	color #dcdcdc
	transition 0.2s ease
	cursor pointer

	padding 0.2em

	&.active
		border-radius 0.2em

		background-color primary
		color darkish

.link:hover
	color #ffe010

	@media (max-width: unit(767, px))
		color darkish

.up
	position fixed
	bottom 0
	left 0
	margin-left 1em
	margin-bottom 1em
	width 2.5em
	height 2.5em
	border-radius 2.5em
	background #ffe010
	z-index 9999

.progselect
	max-width 570px
	margin 0 auto
	text-align center

	.progworkout
		max-width 490px
		margin 0 auto
		p
			text-align left
			font-size 1.2 em
			margin-left 0.7em

.divprogramma
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	@media (max-width: unit(560, px))
		grid-template-columns auto

.programma
	padding 0.4em 0.6em
	border none
	border-bottom 2px solid transparent
	box-sizing border-box
	background-color darkish
	color light
	font-size 1.2em

.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita
	max-width 500px

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.6em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.presdesc
	list-style-type none

	li:before
		content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
		color: #ffe010; /* Change the color */
		font-weight: bold; /* If you want it to be bold */
		display: inline-block; /* Needed to add space between the bullet and the text */
		width: 1em; /* Also needed for space (tweak if needed) */
		margin-left: -1em; /* Also needed for space (tweak if needed) */

.divpres
	text-align center

	img
		display block
		margin 0 auto

.divbox
	display grid
	grid-template-columns auto
	grid-gap 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto
	
	ul
		text-transform uppercase
		font-weight bold

.divul
	text-align left
	margin 0 auto
</style>
